import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-calculation-type',
    templateUrl: './calculation-type.component.html',
    styleUrls: ['./calculation-type.component.scss'],
})
export class CalculationTypeComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() disable: boolean;

    tooltip_position = 'above';
    loading: boolean = false;
    constructor() {}

    ngOnInit(): void {}
}
